import CelebrationModal from "th/celebrationModal";

export { CelebrationModal };

customElements.define(
  "th-celebration-modal",
  CelebrationModal.CustomElementConstructor
);
